import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.updatePosition()
    this.setupListeners()
  }

  openFilterSidebar() {
    const filterButton = document.getElementById("filterButton")
    if (filterButton) {
      filterButton.click()
    }
  }

  updatePosition() {
    const actionMenu = document.querySelector("#action_menu")

    // Get the actual height of the action menu (0 if no action menu exists)
    const actionMenuHeightPx = actionMenu ? actionMenu.offsetHeight : 0

    // Find all sticky captions within this controller and position them below action menu
    const captions = this.element.querySelectorAll("table caption.sticky")
    const captionTop = `${actionMenuHeightPx}px`
    captions.forEach((caption) => {
      caption.style.top = captionTop
    })

    // Calculate caption height to position table header below it
    let captionHeight = 0
    if (captions.length > 0) {
      // Get the height of the first caption (assuming single caption per table)
      captionHeight = captions[0].offsetHeight
    }

    // Calculate total offset for table header (action menu + caption)
    const tableHeaderTop = `${actionMenuHeightPx + captionHeight}px`

    // Find all sticky table headers within this controller
    const tableHeaders = this.element.querySelectorAll("thead tr")
    tableHeaders.forEach((header) => {
      header.style.top = tableHeaderTop
    })
  }

  setupListeners() {
    // Listen for Turbo stream renders
    document.addEventListener("turbo:after-stream-render", () => {
      this.updatePosition()
    })

    // Observe the action_menu element for mutations
    const actionMenu = document.querySelector("#action_menu")
    if (actionMenu) {
      const observer = new MutationObserver(() => {
        this.updatePosition()
      })

      observer.observe(actionMenu, {
        childList: true,
        subtree: true,
        attributes: false,
      })
    }
  }
}
